export default __webpack_public_path__ + "static/join4-18e0c0701b8c9a938256e8aafed8c0c3.png";